export default function safeArray(value: any): [] {
  return value || [];
}
